import { Injectable, TemplateRef, signal } from '@angular/core';

/**
 * PageActionsService: comparte el TemplateRef de los botones de accion de
 * la pagina activa con el shell de la app.
 *
 * Patron tipo "slot": la pagina declara su template con la directiva
 * `appPageActions` (se registra sola), y el shell lo proyecta al lado del
 * breadcrumb. Asi evitamos duplicar el breadcrumb en cada pagina y mantenemos
 * la barra superior visualmente unica.
 *
 * Una sola pagina puede tener actions a la vez (la activa). Si una pagina
 * no declara `<ng-template appPageActions>`, el slot simplemente queda vacio.
 */
@Injectable({ providedIn: 'root' })
export class PageActionsService {
  readonly template = signal<TemplateRef<unknown> | null>(null);

  set(tpl: TemplateRef<unknown> | null): void {
    this.template.set(tpl);
  }

  clearIfMatches(tpl: TemplateRef<unknown>): void {
    // Solo limpiamos si el template actual sigue siendo el nuestro.
    // Asi evitamos race conditions en transiciones de ruta donde el
    // ngOnInit del nuevo componente podria correr antes del ngOnDestroy
    // del anterior (y borrariamos el template recien registrado).
    if (this.template() === tpl) {
      this.template.set(null);
    }
  }
}
